export default {
	// 404页面
	// notFound:() => import( /* webpackChunkName: "NotFound" */ '../../views/base/notFound.vue'),
	// 工作台
	workbench:() => import( /* webpackChunkName: "workbench" */ '../../views/base/login.vue'),

	//登录页面
	// login:() => import( /* webpackChunkName: "login" */ '../../views/base/login.vue'),
	// //选择企业
	// chooseCompany:() => import( /* webpackChunkName: "chooseCompany" */ '../../views/base/chooseCompany.vue'),
	// //绑定成功
	// bindSucces:() => import( /* webpackChunkName: "bindSucces" */ '../../views/base/bindSucces.vue'),
	// //解绑页面
	// unbindWx:() => import( /* webpackChunkName: "unbindWx" */ '../../views/base/unbindWx.vue'),
	//绑定信息
	bindInfo:() => import( /* webpackChunkName: "bindInfo" */ '../../views/base/bindInfo.vue')

	
}